/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EodMelcoEodModelsPartnerListItem,
    EodMelcoEodModelsPartnerListItemFromJSON,
    EodMelcoEodModelsPartnerListItemFromJSONTyped,
    EodMelcoEodModelsPartnerListItemToJSON,
    EodMelcoModelsCustomWarning,
    EodMelcoModelsCustomWarningFromJSON,
    EodMelcoModelsCustomWarningFromJSONTyped,
    EodMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem
 */
export interface EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem {
    /**
     * 
     * @type {Array<EodMelcoEodModelsPartnerListItem>}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem
     */
    list: Array<EodMelcoEodModelsPartnerListItem>;
    /**
     * 
     * @type {Array<EodMelcoModelsCustomWarning>}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem
     */
    warning_list?: Array<EodMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem
     */
    total: number;
}

export function EodMelcoModelsGenericList1MelcoEodModelsPartnerListItemFromJSON(json: any): EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem {
    return EodMelcoModelsGenericList1MelcoEodModelsPartnerListItemFromJSONTyped(json, false);
}

export function EodMelcoModelsGenericList1MelcoEodModelsPartnerListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EodMelcoEodModelsPartnerListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EodMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EodMelcoModelsGenericList1MelcoEodModelsPartnerListItemToJSON(value?: EodMelcoModelsGenericList1MelcoEodModelsPartnerListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EodMelcoEodModelsPartnerListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EodMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


